import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { gql } from '@apollo/client'

export const adjustmentRemarksActivityFragment = gql`
  fragment adjustmentRemarksActivityFragment on Activity {
    _id
    activity
    by {
      _id
      profile {
        _id
        name
        picture
      }
    }
    updatedAt
    isDeleted
  }
`

export const adjustmentFragment = gql`
  fragment adjustmentFragment on Adjustment {
    _id
    tags
    createdAt
    updatedAt
    status
    completionDate
    cancellationDate
    code
    items {
      _id
      quantity
      product {
        _id
        code
        status
        name
        requiredSerialNumber
        serialNumberType
        hasSubComponents
        inventory {
          _id
          quantityOnHand
        }
        requiredComputedQuantityOnHand
        baseUom {
          _id
          symbol
        }
        unitOfMeasurePrecision
        inventoryBySerialNumbers(filter: { status: "OnHand" }, options: { limit: 0, sort: { code: 1 } }) {
          _id
          code
          status
          remarks
          tags
        }
      }
      remarks
      tags
      inventoryBySerialNumbers {
        _id
        code
        remarks
        tags
      }
    }
    inventorySerialNumbers {
      _id
      code
      transactionType
      transactionRef
      batchCode
      status
      product {
        _id
        code
      }
      order {
        _id
        code
      }
    }
    remarksActivity {
      ...adjustmentRemarksActivityFragment
    }
  }
  ${adjustmentRemarksActivityFragment}
`

export const adjustmentListFragment = gql`
  fragment adjustmentListFragment on Adjustment {
    ...adjustmentFragment
  }
  ${adjustmentFragment}
`

export const adjustmentDocumentQueries = buildGraphqlQuery('Adjustment', adjustmentFragment, ['items'])
